import { memo } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Button, { BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import Dialog from "app/pages/.shared/Dialog/Dialog";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import "./AlertDialog.scss";

const AlertDialog = ({ isDialogOpen, onCloseModal = () => {}, title, message, buttonLabel }) => {
	if (!title && !message) {
		return null;
	}

	return (
		<Dialog isDialogOpen={isDialogOpen} onOpenChange={onCloseModal}>
			<div className="alert-dialog">
				{title && (
					<div className="alert-dialog__title">
						<Typography variant={TYPOGRAPHY_VARIANTS.XL} isBold>
							{title}
						</Typography>
					</div>
				)}
				{message && <div className="alert-dialog__message">{message}</div>}
				<div className="alert-dialog__action">
					<Button
						variant={BUTTON_VARIANTS.FILLED}
						onClick={onCloseModal}
						label={
							buttonLabel || <FormattedMessage id="alert.data.updated.button.label" />
						}
					/>
				</div>
			</div>
		</Dialog>
	);
};

AlertDialog.propTypes = {
	title: PropTypes.string,
	message: PropTypes.string,
	buttonLabel: PropTypes.string,
	isDialogOpen: PropTypes.bool,
	onCloseModal: PropTypes.func,
};

export default memo(AlertDialog);
